import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector, SubmissionError, change, untouch } from "redux-form";
import _ from "lodash";
import { Link } from "react-router";
import Title from "../../components/Layout/Title";
import { toastr } from "react-redux-toastr";
import api from "../../api/apiUtil";
import ReactTable from "react-table";
import SelectField from "../../components/Fields/SelectField";
import TextareaField from "../../components/Fields/TextareaField";
import FieldValidation from "../../components/Validation/FieldValidation";
import { MONITOR_ALL_COMPANIES_LOAD, MONITOR_ALL_LIST, LOGOUT, CONFIRM_ACTION_OPEN, MONITOR_UNLOAD } from "../../actions/Constants";
import DropdownListField from "../../components/Fields/DropdownListField";

class Monitoramento extends React.Component {
  constructor() {
    super();
    this.state = {
      configurar: false,
      monitoramentoExclusao: {},
      horarios: [],
      diasSemana: [
        { id: 1, name: "Domingo" },
        { id: 2, name: "Segunda-feira" },
        { id: 3, name: "Terça-feira" },
        { id: 4, name: "Quarta-feira" },
        { id: 5, name: "Quinta-feira" },
        { id: 6, name: "Sexta-feira" },
        { id: 7, name: "Sábado" },
      ],
      horasDisponiveis: this.gerarHorasDisponiveis(),
      monitoramentos: [],
    };
  }

  gerarHorasDisponiveis = () => {
    const horas = [];
    for (let i = 1; i <= 24; i++) {
      horas.push({
        id: i,
        name: i.toString().padStart(2, "0") + ":00",
      });
    }
    return horas;
  };

  componentDidMount() {
    this.props.onCompaniesLoad(api.Financial.allFinancial());
    this.carregarMonitoramentos();
  }

  componentWillUnmount() {
    this.props.onMonitorUnload();
  }

  carregarMonitoramentos = async () => {
    try {
      const response = await api.Monitoramento.getAll();
      this.props.onMonitoringsLoad(response);
    } catch (error) {
      console.error("Erro ao carregar monitoramentos:", error);
      toastr.error("Erro", "Ocorreu um erro ao carregar os monitoramentos!");
    }
  };

  recuperaNotificacao = async () => {
    try {
      const ret = await api.Configuracao.getPorAtributo("EMAILS_MONITORAMENTO");
      if (ret) {
        this.props.dispatch(change("MonitoramentoForm", "emailsNotificar", JSON.parse(ret.valor).emailsNotificar));
        this.setState({ configurar: !this.state.configurar });
      }
    } catch (resp) {
      if (resp.status === 403) {
        toastr.warning("Atenção", resp.response.body.message);
      } else if (resp === "Unauthorized" || resp === "jwt expired") {
        api.Auth.logout();
        this.props.onLogout();
      } else {
        toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
      }
    }
  };

  configurarNotif = async (values) => {
    try {
      const params = {
        valor: JSON.stringify({ emailsNotificar: values.emailsNotificar }),
        atributo: "EMAILS_MONITORAMENTO",
      };
      await api.Configuracao.putConfig(params);
      this.setState({ configurar: !this.state.configurar });
      toastr.success("Sucesso", "E-mails para notificação alterados.");
    } catch (resp) {
      if (resp.status === 403) {
        toastr.warning("Atenção", resp.response.body.message);
      } else if (resp === "Unauthorized" || resp === "jwt expired") {
        api.Auth.logout();
        this.props.onLogout();
      } else {
        toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
      }
    }
  };

  cadastrar = async (values) => {
    let valid = true;

    // Processar dias da semana selecionados
    const diasSelecionados = [];
    for (let i = 1; i <= 7; i++) {
      if (values[`dia_${i}`]) {
        diasSelecionados.push(i);
      }
    }

    // Processar horários selecionados
    const horasSelecionadas = [];
    for (let i = 1; i <= 24; i++) {
      if (values[`hora_${i}`]) {
        horasSelecionadas.push(i);
      }
    }

    if (diasSelecionados.length === 0) {
      toastr.warning("Atenção", "Selecione pelo menos um dia da semana.");
      valid = false;
    }

    if (horasSelecionadas.length === 0) {
      toastr.warning("Atenção", "Selecione pelo menos um horário.");
      valid = false;
    }

    const errors = this.validateValues(values);
    if (errors && !_.isEmpty(errors)) {
      valid = false;
      throw new SubmissionError(errors);
    }

    if (!valid) {
      return;
    }

    try {
      const payload = {
        idFinanceira: values.credor.id ? values.credor.id : values.credor,
        dias: diasSelecionados.join(","),
        horas: horasSelecionadas.join(","),
        horainicio: parseInt(values.horarioInicio),
        horaFim: parseInt(values.horarioFim),
        incluiFilhas: values.incluiFiliais ? 1 : 0,
      };

      await api.Monitoramento.create(payload);

      toastr.success("Sucesso", "Monitoramento cadastrado com sucesso.");
      this.carregarMonitoramentos();
      this.limparCampos();
    } catch (error) {
      console.error("Erro ao cadastrar monitoramento:", error);
      if (error.status === 403 || error.status === 400) {
        toastr.warning("Atenção", error.response.body.message);
      } else if (error === "Unauthorized" || error === "jwt expired") {
        api.Auth.logout();
        this.props.onLogout();
      } else {
        toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
      }
    }
  };

  validateValues(values) {
    const errors = {};
    if (values.credor == undefined || values.credor == null || !values.credor.id || values.credor.id == 0) {
      errors.credor = "Campo obrigatório";
    }

    if (!values.horarioInicio) {
      errors.horarioInicio = "Campo obrigatório";
    }
    if (!values.horarioFim) {
      errors.horarioFim = "Campo obrigatório";
    }
    return errors;
  }

  limparCampos = () => {
    this.props.dispatch(change("MonitoramentoForm", "credor", null));
    this.props.dispatch(change("MonitoramentoForm", "incluiFiliais", true));
    this.props.dispatch(change("MonitoramentoForm", "horarioInicio", null));
    this.props.dispatch(change("MonitoramentoForm", "horarioFim", null));

    this.state.diasSemana.forEach((dia) => {
      this.props.dispatch(change("MonitoramentoForm", `dia_${dia.id}`, false));
    });

    this.state.horarios.forEach((hora) => {
      this.props.dispatch(change("MonitoramentoForm", `hora_${hora.id}`, false));
    });

    this.setState({ horarios: [] });
    this.props.dispatch(untouch("MonitoramentoForm"));
  };

  alterarHorario = (inicio, fim) => {
    if (inicio && fim) {
      const inicioInt = parseInt(inicio);
      const fimInt = parseInt(fim);

      if (inicioInt <= fimInt) {
        const novosHorarios = Array.from({ length: fimInt - inicioInt + 1 }, (_, i) => ({
          id: inicioInt + i,
          name: (inicioInt + i).toString().padStart(2, "0") + ":00",
        }));
        this.setState({ horarios: novosHorarios });
        return;
      } else {
        this.setState({ horarios: [] });
      }
    } else {
      this.setState({ horarios: [] });
    }
  };

  onActionDeleteOpen = (id) => {
    this.setState({ monitoramentoExclusao: { id } });
    this.props.onActionOpen({
      description: `Confirma a exclusão do monitoramento?`,
      onSuccess: this.handleOnDelete.bind(this),
    });
  };

  handleOnDelete = async () => {
    try {
      await api.Monitoramento.delete(this.state.monitoramentoExclusao.id);
      toastr.success("Sucesso", "Monitoramento excluído com sucesso.");
      this.carregarMonitoramentos();
      this.setState({ monitoramentoExclusao: {} });
    } catch (error) {
      console.error("Erro ao excluir monitoramento:", error);
      if (error.status === 403) {
        toastr.warning("Atenção", error.response.body.message);
      } else if (error === "Unauthorized" || error === "jwt expired") {
        api.Auth.logout();
        this.props.onLogout();
      } else {
        toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
      }
    }
  };

  render() {
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} />
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <form className="form-horizontal">
                <div className="hpanel">
                  {this.props.currentUser.funcionalidades.includes(109) && (
                    <>
                      <div className="panel-heading">
                        <Link className="btn btn-xs btn-info" onClick={() => this.recuperaNotificacao()}>
                          <i className="fas fa-book" /> Configurar E-mails
                        </Link>
                        <div className="panel-tools">
                          <br></br>
                        </div>
                      </div>

                      {this.state.configurar && (
                        <div className="panel-body">
                          <div className="row">
                            <div className="col-md-12">
                              <Field name="emailsNotificar" label="E-mails a serem notificados" component={TextareaField} type="text" rows={2} required validate={[FieldValidation.required]} />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="text-right">
                                <button className="btn btn-default mr-2" type="button" onClick={() => this.setState({ configurar: !this.state.configurar })}>
                                  Cancelar
                                </button>
                                <button className="btn btn-success" type="button" onClick={this.props.handleSubmit(this.configurarNotif.bind(this))}>
                                  Salvar
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <br></br>
                    </>
                  )}
                  {this.props.currentUser.funcionalidades.includes(110) && (
                    <div className="panel-body">
                      <div className="m-b-md">
                        <h5>Configurações de Monitoramento</h5>
                      </div>
                      {/* Seleção de Financeira e Filiais */}
                      <div className="row">
                        <div className="col-md-6">
                          <Field
                            name="credor"
                            label="Financeira"
                            data={this.props.allCompanies}
                            credor={true}
                            required
                            textField="razaoSocialCnpj"
                            valueField="id"
                            component={DropdownListField}
                            type="text"
                            onChange={() => {
                              this.props.dispatch(change("MonitoramentoForm", "incluiFiliais", true));
                            }}
                            // validate={[FieldValidation.required]}
                          />
                        </div>
                        {this.props.selectFinanceira && (
                          <div className="col-md-6 d-flex align-items-center">
                            <Field name="incluiFiliais" id="incluiFiliais" component="input" type="checkbox" defaultChecked={true} />
                            <label htmlFor="incluiFiliais" className="ml-2 mb-0">
                              Incluir filiais/credenciadas
                            </label>
                          </div>
                        )}
                      </div>

                      {/* Hora início e fim */}
                      {this.props.selectFinanceira && (
                        <>
                          <div className="row mt-3">
                            <div className="col-md-6">
                              <Field
                                name="horarioInicio"
                                label="Hora início"
                                blank={true}
                                data={this.state.horasDisponiveis}
                                component={SelectField}
                                type="text"
                                valueField="id"
                                textField="name"
                                required={true}
                                onChange={(e, value) => this.alterarHorario(value, this.props.selectHorarioFim)}
                                // validate={[FieldValidation.required]}
                              />
                            </div>
                            <div className="col-md-6">
                              <Field
                                name="horarioFim"
                                label="Hora fim"
                                blank={true}
                                data={this.state.horasDisponiveis}
                                component={SelectField}
                                type="text"
                                valueField="id"
                                textField="name"
                                required={true}
                                onChange={(e, value) => this.alterarHorario(this.props.selectHorarioInicio, value)}
                                // validate={[FieldValidation.required]}
                              />
                            </div>
                          </div>

                          {/* Dias da semana */}
                          <div className="row mt-3">
                            <div className="col-md-12">
                              <label>Dias da semana</label>
                              <div className="row">
                                {this.state.diasSemana.map((dia, index) => (
                                  <div key={dia.id} className="col-md-1 col-3 mb-2">
                                    <Field name={`dia_${dia.id}`} id={`dia_${dia.id}`} component="input" type="checkbox" />
                                    <label htmlFor={`dia_${dia.id}`} className="ml-1 mb-0">
                                      {dia.name.substring(0, 3)}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>

                          {/* Horários disponíveis baseados no range */}
                          {this.state.horarios.length > 0 && (
                            <div className="row mt-3">
                              <div className="col-md-12">
                                <label>Horários de verificação</label>
                                <div className="row">
                                  {this.state.horarios.map((hora) => (
                                    <div key={hora.id} className="col-md-1 col-3 mb-2">
                                      <Field name={`hora_${hora.id}`} id={`hora_${hora.id}`} component="input" type="checkbox" />
                                      <label htmlFor={`hora_${hora.id}`} className="ml-1 mb-0">
                                        {hora.name}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Botões de ação */}
                          <div className="row mt-4">
                            <div className="col-md-12">
                              <div className="text-right">
                                <button className="btn btn-default mr-2" type="button" onClick={this.limparCampos}>
                                  Cancelar
                                </button>
                                <button className="btn btn-success" type="button" onClick={this.props.handleSubmit(this.cadastrar.bind(this))}>
                                  Salvar
                                </button>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* Lista de monitoramentos ativos */}
                <div className="hpanel">
                  <div className="panel-heading">
                    <h4>Alertas Ativos</h4>
                  </div>
                  <div className="panel-body">
                    <div className="table-responsive">
                      <ReactTable
                        className="-striped -highlight"
                        defaultPageSize={10}
                        data={this.props.monitoramentos}
                        loadingText="Carregando..."
                        noDataText="Nenhum monitoramento encontrado"
                        rowsText="linhas"
                        showPageSizeOptions={false}
                        minRows={1}
                        showPagination={true}
                        previousText="Anterior"
                        nextText="Próximo"
                        pageText="página"
                        ofText="de"
                        columns={[
                          {
                            Header: "Financeira",
                            accessor: "razaoSocial",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                          },
                          {
                            Header: "CNPJ",
                            accessor: "cnpj",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 150,
                          },
                          {
                            Header: "Dias",
                            accessor: "dias",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            Cell: (row) => {
                              const diasIds = row.original.dias.split(",").map(Number);
                              const diasNomes = diasIds
                                .map((id) => {
                                  const dia = this.state.diasSemana.find((d) => d.id === id);
                                  return dia ? dia.name.substring(0, 3) : "";
                                })
                                .join(", ");
                              return <div>{diasNomes}</div>;
                            },
                          },
                          {
                            Header: "Horas",
                            accessor: "horas",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            Cell: (row) => {
                              const horasFormatadas = row.original.horas.split(",").map((h) => h.trim().padStart(2, "0") + ":00");
                              return <div>{horasFormatadas.join(", ")}</div>;
                            },
                          },
                          {
                            Header: "Horário Início",
                            accessor: "horainicio",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            Cell: (row) => {
                              return <div>{(row.original.horainicio || "").toString().padStart(2, "0") + ":00"}</div>;
                            },
                            width: 120,
                          },
                          {
                            Header: "Horário Fim",
                            accessor: "horaFim",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            Cell: (row) => {
                              return <div>{(row.original.horaFim || "").toString().padStart(2, "0") + ":00"}</div>;
                            },
                            width: 120,
                          },
                          {
                            Header: "Inclui Filiais",
                            accessor: "incluiFilhas",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            Cell: (row) => {
                              return <div>{row.original.incluiFilhas ? "Sim" : "Não"}</div>;
                            },
                            width: 120,
                          },
                          {
                            Header: "Ações",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 100,
                            Cell: (row) => (
                              <div className="btn-group">
                                {this.props.currentUser.funcionalidades.includes(111) && (
                                  <button className="btn btn-sm btn-danger" onClick={() => this.onActionDeleteOpen(row.original.id)} title="Excluir">
                                    <i className="fas fa-trash"></i>
                                  </button>
                                )}
                              </div>
                            ),
                          },
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onCompaniesLoad: (payload) => dispatch({ type: MONITOR_ALL_COMPANIES_LOAD, payload }),
  onMonitoringsLoad: (payload) => dispatch({ type: MONITOR_ALL_LIST, payload }),
  onActionOpen: (payload) => dispatch({ type: CONFIRM_ACTION_OPEN, payload }),
  onMonitorUnload: () => dispatch({ type: MONITOR_UNLOAD }),
  onLogout: () => dispatch({ type: LOGOUT }),
});

const selector = formValueSelector("MonitoramentoForm");
const mapStateToProps = (state) => ({
  ...state.monitoramento,
  currentUser: state.common.currentUser,
  selectFinanceira: selector(state, "credor"),
  selectHorarioInicio: selector(state, "horarioInicio"),
  selectHorarioFim: selector(state, "horarioFim"),
});

const form = reduxForm({
  form: "MonitoramentoForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(Monitoramento));
